/*
  Lineup: tasting-note flip cards and the barrel count the pick section reads.

  Moved out of sections/brewzle-lineup.liquid on 2026-09-21. It was inline, so it ran during
  parse and held up first paint: Lighthouse put 1,841ms of main thread on the
  document itself, and the hero photo, already downloaded by ~480ms, was waiting
  on it. Loaded with defer instead, which runs after the document is parsed.

  The code is unchanged apart from the root lookup. It used to interpolate the
  section id into a class selector; it now finds the same element by the
  data-bz-section attribute the section already carries.
*/
(function () {
    var root = document.getElementById('bz-lineup');
    if (!root) return;
    var scroller = root.querySelector('[data-bz-scroller]');
    if (!scroller) return;
    // Read by the funnel's Brewzle events (analytics-posthog-funnel.js).
    window.__BREWZLE_BARREL_COUNT__ = scroller.querySelectorAll('[data-bz-card]').length;

    // Tasting-notes flip. Both buttons on a card toggle the same state; the
    // funnel listens for bz-lineup:notes-toggled (brewzle_tasting_notes_toggled).
    scroller.addEventListener('click', function (e) {
      var button = e.target && e.target.closest ? e.target.closest('[data-bz-flip]') : null;
      if (!button) return;
      var card = button.closest('.bz-card');
      if (!card) return;
      var open = !card.classList.contains('is-flipped');
      card.classList.toggle('is-flipped', open);
      var back = card.querySelector('.bz-card__face--back');
      if (back) back.setAttribute('aria-hidden', open ? 'false' : 'true');
      var buttons = card.querySelectorAll('[data-bz-flip]');
      for (var i = 0; i < buttons.length; i++) buttons[i].setAttribute('aria-expanded', open ? 'true' : 'false');
      var focusTarget = card.querySelector(open ? '.bz-card__flip--close' : '.bz-card__face--front [data-bz-flip]');
      if (focusTarget) focusTarget.focus({ preventScroll: true });
      try {
        root.dispatchEvent(new CustomEvent('bz-lineup:notes-toggled', {
          bubbles: true,
          detail: { card: card.getAttribute('data-bz-card'), open: open }
        }));
      } catch (err) { /* CustomEvent unsupported: analytics only */ }
    });
  })();
